module.exports = __webpack_public_path__ + "static/media/hanjin_genoa.cfebf979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hanjin_genoa.jpg
// module id = 307
// module chunks = 0